import { RHFSelect, RHFTextField } from 'src/components/hook-form';
export default function ActivitySecondRow({
  calculationofWorkdays,
  calculationofLaborHrsInDetail,
}) {
  return (
    <>
      <RHFTextField
        type="number"
        name="daily_production_rate_per_shift"
        label="Daily Production Rate per Shift"
        onChange={(e) => {
          calculationofWorkdays(e.target.value, 'daily_production_rate_per_shift');
        }}
      />
      <RHFTextField
        type="number"
        name="difficulty_factor"
        label="Difficulty factor (More Difficulty Enter Less Then 1)"
        onChange={(e) => {
          calculationofWorkdays(e.target.value, 'difficulty_factor');
        }}
      />
      <RHFSelect
        native
        name="no_of_shifts"
        label="No of Shifts"
        InputLabelProps={{ shrink: true }}
        onChange={(e) => {
          calculationofWorkdays(e.target.value, 'no_of_shifts');
          calculationofLaborHrsInDetail(e.target.value, 'no_of_shifts');
        }}
      >
        {[1, 2, 3].map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </RHFSelect>
      <RHFTextField
        type="number"
        name="shift_hours"
        label="Shift Hours"
        onChange={(e) => {
          calculationofLaborHrsInDetail(e.target.value, 'shift_hours');
        }}
      />
    </>
  );
}
